import IntroContainer from "./IntroContainer";

export default IntroContainer;
